<section
  class="overflow-touch bg-myportal-one flex flex-col overflow-y-auto bg-cover bg-top bg-no-repeat md:min-h-[calc(100vh-220px)] lg:bg-contain"
  id="ticketPage"
>
  <app-ticket-top
    [isLoading]="loadingAggregateStats"
    [aggregate]="ticketAggregate"
    [tickets]="(filteredTickets$ | async)?.data || []"
    (timeRangeChanged)="onTimeRangeChanged($event)"
    class="mb-2 md:mb-0"
  >
  </app-ticket-top>
  <div
    class="flex min-h-[calc(100vh-250px)] justify-between gap-4 pb-0 pr-0 md:pl-4 md:pt-4"
  >
    <app-ticket-list-display
      class="flex-1 overflow-hidden bg-white md:rounded-t-xl md:shadow-lg"
      [browserSize]="browserSize$ | async"
      [totalTickets]="(filteredTickets$ | async)?.total || 0"
      [tickets]="(filteredTickets$ | async)?.data || []"
      [isLoading]="isLoadingFilteredTickets"
      [csvData]="ticketCsvData"
      (selectTicket)="onSelectTicket($event)"
      (openCreateTicketDialog)="openDialog()"
      (paginationChanged)="onPaginationChanged($event)"
      [pageSize]="pageSize"
      [currentPage]="page"
      (searchChanged)="onSearchChanged($event)"
    ></app-ticket-list-display>

    <app-tickets-detail-shell
      class="hidden flex-1 overflow-hidden rounded-tl-xl bg-white shadow-lg md:block"
      [isLoading]="isLoadingFilteredTickets"
    ></app-tickets-detail-shell>
  </div>
</section>
